import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Svg from './BaseIcon';
const ArrowIcon = ({ color, className, testId, }) => {
    const { colors } = useTheme();
    const iconColor = color ? color : colors.text.default;
    return (_jsx(Svg, { className: className, "data-cy": testId, width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", children: _jsx("path", { d: "M12.8346 7.0013H1.16797M1.16797 7.0013L7.0013 12.8346M1.16797 7.0013L7.0013 1.16797", stroke: iconColor, strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
export default ArrowIcon;
//# sourceMappingURL=ArrowIcon.js.map